/**
 * Labstep
 *
 * @module components/FilterPost/Report/MetadataHasValue
 * @desc Metadata has value filter
 */

import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import {
  PostFilterComparison,
  PostFilterOperator,
} from 'labstep-web/services/postFilter/constants';
import { getPostFilterMetadatasHasValue } from 'labstep-web/services/postFilter/filters/metadatas';
import type React from 'react';
import type { FilterPostReportMetadataHasValueProps } from './types';

export const FilterPostReportMetadataHasValue: React.FC<
  FilterPostReportMetadataHasValueProps
> = ({ path, addPostFilter, metadataLabel, protocolValueName }) => (
  <ActionComponent
    type="option"
    icon={ICONS.metadata.secondary}
    text="Only show rows with data in this field"
    onClick={() => {
      const filter = getPostFilterMetadatasHasValue(path);

      if (protocolValueName) {
        const complexFilterNode = {
          type: PostFilterOperator.and,
          path: 'protocolValues',
          predicates: [
            {
              attribute: 'name',
              comparison: PostFilterComparison.eq,
              value: protocolValueName,
            },
            filter.getNode([
              metadataLabel || '',
              ['', PostFilterComparison.not_null],
            ]),
          ],
        };
        addPostFilter(complexFilterNode as any, true);
      } else {
        addPostFilter(
          filter.getNode([
            metadataLabel || '',
            ['', PostFilterComparison.not_null],
          ]),
          true,
        );
      }
    }}
  />
);
